import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customerFormat',
    pure: true,
    standalone: false
})
export class CustomerFormatPipe implements PipeTransform {
  transform(row: any, ...args: unknown[]): string {
    return row.customer?.name || "";
  }
}